import React, { useState } from 'react';
import DimpleDivider from '@tds/core-dimple-divider';

import TabSelection from './tabSelection';
import ManagedITService from './managedITServices';
import MicrosoftLicensing from './microsoftLicensing';

const FullyManaged = () => {
  const [selectedTab, setSelectedTab] = useState('MANAGED_IT_SERVICE');

  return (
    <>
      <TabSelection selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <DimpleDivider />
      {selectedTab === 'MANAGED_IT_SERVICE' ? (
        <ManagedITService />
      ) : (
        <MicrosoftLicensing />
      )}
    </>
  );
};

export default FullyManaged;
